import { createContext } from 'react';
const StateContext = createContext<any>(null);
export default StateContext;